/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  testResults:null,
  reports:null,
  insightVector:[],
  attends:null,
  attendVector:[],
  projectsInfo:[],
  insightMonth:[],
  userType:[],
  userMonth:[]
}
